import { render } from "./ProductsProductCart.vue?vue&type=template&id=27b8b34e"
import script from "./ProductsProductCart.vue?vue&type=script&lang=js"
export * from "./ProductsProductCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__